import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import UserService from '../services/UserService';
import { RegistrationStatus } from '../models/RegistrationStatus';
import { map, catchError, of } from 'rxjs';

// Block access for customers with pending activation
export const customerActiveGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  return userService.getMe().pipe(
    map((response: any) => {
      // Check if user is a customer
      if (response.userType !== 'customer' || !response.customer) {
        console.log('[CustomerActiveGuard] User is not a customer, denying access');
        router.navigate(['/']);
        return false;
      }

      const customer = response.customer;
      const status: RegistrationStatus | undefined = customer?.registrationStatus;
      const isActive = !!customer?.isActive;
      console.log('[CustomerActiveGuard] Customer status:', status, 'isActive:', isActive, 'customer:', customer);
      
      if (!isActive || status === RegistrationStatus.Pending) {
        console.log('[CustomerActiveGuard] Customer not active or pending, redirecting to pending page');
        router.navigate(['customer/pending']);
        return false;
      }
      console.log('[CustomerActiveGuard] Customer is active, allowing access');
      return true;
    }),
    catchError((error) => {
      console.error('[CustomerActiveGuard] Error fetching user data:', error);
      console.log('[CustomerActiveGuard] Redirecting to pending due to error');
      router.navigate(['customer/pending']);
      return of(false);
    })
  );
};
